export default __webpack_public_path__ + "static/media/illustration-dino.18acb110.png";